import Inputmask from "inputmask";


document.addEventListener('DOMContentLoaded', () => {
    const jsphone = document.querySelectorAll('.js-phone');
    jsphone.forEach((phone, index) => {
        Inputmask({
            mask: "+7 (999) 999-99-99",
            showMaskOnHover: false,
            placeholder: '_'
        }).mask(phone);
    });

});
